module.exports = __webpack_public_path__ + "static/img/review-01.14689f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/review-01.jpg
// module id = 3tPv
// module chunks = 1